import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Music from '../components/Music';
import FourSeals from '../components/FourSeals';
import Gallery from '../components/Gallery';
import Roadmap from '../components/Roadmap';
import PressContact from '../components/PressContact';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import ParticleEffect from '../components/ParticleEffect';

const EclipseHeavenPage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground film-grain sacred-pattern">
      <ParticleEffect />
      <Navigation scrolled={scrolled} />
      
      <main>
        <Hero />
        <About />
        <Music />
        <FourSeals />
        <Gallery />
        <Roadmap />
        <PressContact />
      </main>
      
      <Footer />
      <BackToTop />
    </div>
  );
};

export default EclipseHeavenPage;